import { observer } from 'mobx-react-lite';
import React from 'react';
import { colors } from '../../../../../../colorVars';
import { Body3 } from '../../../../../atomic/text/Text';
import { getNotificationSymbol } from '../../../../../../stores/websocketStore/utils/mungingUtils/notifications/higherOrderHandlers/getNotificationSymbol';
import { getNotificationType } from '../../../../../../stores/websocketStore/utils/mungingUtils/notifications/higherOrderHandlers/getNotificationType';
import { timeStampTo24HourEST } from '../../../../../../stores/websocketStore/utils/mungingUtils/timeFormatting/timeStampTo24HourEST';
import style from './NotificationRow.module.css';
import * as ReactDOMServer from 'react-dom/server';

import { getNotificationStatusComponent } from '../../../../../../stores/websocketStore/utils/mungingUtils/notifications/higherOrderHandlers/getNotificationStatusComponent';
const notificationTypeToColorMap = {
  TRADE_PLAN_UPDATE: colors.blue,
  WARNING: colors.orange,
  ERROR: colors.red,
};
export const NotificationRow = observer(
  ({ notification, setSelectedNotification, selectedNotification }) => {
    const time = timeStampTo24HourEST(notification.timestamp);
    const symbol = getNotificationSymbol(notification) ?? 'N/A';
    const { type, text } = getNotificationType(notification);
    const [StatusComponent, parsedStatusObj] = getNotificationStatusComponent(
      notification
    ) ?? [null, null];
    const string = StatusComponent
      ? ReactDOMServer.renderToString(
          <StatusComponent parsedStatusObj={parsedStatusObj} />
        ).replace(/<[^>]*>/g, '')
      : '';

    return (
      <tr
        title={string}
        className={
          selectedNotification?.notificationId === notification.notificationId
            ? style.selectedContainer
            : style.container
        }
        onClick={() => setSelectedNotification(notification)}
      >
        <td>
          <Body3 fontWeight={500} color={colors.lightGrey}>
            {time}
          </Body3>
        </td>
        <td>
          <Body3 fontWeight={500} color={colors.lightGrey}>
            {symbol}
          </Body3>
        </td>
        <td>
          <Body3 fontWeight={500} color={notificationTypeToColorMap[type]}>
            {text}
          </Body3>
        </td>
        {StatusComponent ? (
          <StatusComponent parsedStatusObj={parsedStatusObj} />
        ) : (
          <td></td>
        )}
        <td>
          <Body3 fontWeight={500} color={colors.lightGrey}>
            {notification.notificationDetails?.TRADE_PLAN?.watchlistName}
          </Body3>
        </td>
      </tr>
    );
  }
);
